import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

const TakeAssessment = React.lazy(() => import("./TakeAssessment"));
const AssessmentHistory = React.lazy(() => import("./AssessmentHistory"));
const AssessmentDetail = React.lazy(() => import("./AssessmentDetail"));
const AssessmentComparison = React.lazy(() => import("./AssessmentComparison"));
const AssessmentDomains = React.lazy(() => import("./AssessmentDomains"));
const AssessmentCustomFields = React.lazy(() => import("./AssessmentCustomFields"));
const AssessmentAdmin = React.lazy(() => import("./AssessmentAdmin"));
const AssessmentClientHistory = React.lazy(() => import("./AssessmentClientHistory"));
const AssessmentNotificationRules = React.lazy(() => import("./AssessmentNotificationRules"));
// SurgReady assessment program (2026-10-24)
const AssessmentHome = React.lazy(() => import("./AssessmentHome"));
const AssessmentStart = React.lazy(() => import("./AssessmentStart"));
const MedicalVault = React.lazy(() => import("./MedicalVault"));
const AssessmentTake = React.lazy(() => import("./AssessmentTake"));
const AssessmentProgramAdmin = React.lazy(() => import("./AssessmentProgramAdmin"));

const assessmentSnapshotModuleConfig: ModuleConfig = {
  id: "assessment-snapshot",
  name: "Health Assessment",
  description: "Pre-surgery health assessments with progress tracking",
  version: "1.0.0",
  enabled: true,
  category: "medical",
  order: 5,
  icon: "🩺",
  color: "#4A90E2",

  routes: [
    // With the SurgReady program on, /assessment opens the starting questions or the health record;
    // without it, the original wizard (also always at /assessment/readiness).
    { path: "/assessment", component: AssessmentHome, permissionLevel: "view", useLayout: true },
    { path: "/assessment/readiness", component: TakeAssessment, permissionLevel: "view", useLayout: true },
    { path: "/assessment/start", component: AssessmentStart, permissionLevel: "view", useLayout: true },
    { path: "/assessment/vault", component: MedicalVault, permissionLevel: "view", useLayout: true },
    { path: "/assessment/q/:key", component: AssessmentTake, permissionLevel: "view", useLayout: true },
    { path: "/assessment/program", component: AssessmentProgramAdmin, permissionLevel: "admin", useLayout: true },
    { path: "/assessment/history", component: AssessmentHistory, permissionLevel: "view", useLayout: true },
    { path: "/assessment/snapshot/:id", component: AssessmentDetail, permissionLevel: "view", useLayout: true },
    { path: "/assessment/compare", component: AssessmentComparison, permissionLevel: "view", useLayout: true },
    { path: "/assessment/domains", component: AssessmentDomains, permissionLevel: "admin", useLayout: true },
    { path: "/assessment/custom-fields", component: AssessmentCustomFields, permissionLevel: "admin", useLayout: true },
    { path: "/assessment/admin", component: AssessmentAdmin, permissionLevel: "admin", useLayout: true },
    { path: "/assessment/admin/client/:userId", component: AssessmentClientHistory, permissionLevel: "admin", useLayout: true },
    { path: "/assessment/notifications", component: AssessmentNotificationRules, permissionLevel: "admin", useLayout: true },
  ],

  navigation: [
    { label: "My health record", path: "/assessment/vault", icon: "🗂️", permissionLevel: "view" },
    { label: "Starting questions", path: "/assessment/start", icon: "🏁", permissionLevel: "view" },
    { label: "Take Assessment", path: "/assessment", icon: "📝", permissionLevel: "view" },
    { label: "My Assessments", path: "/assessment/history", icon: "📊", permissionLevel: "view" },
    { label: "Manage Domains", path: "/assessment/domains", icon: "⚙️", permissionLevel: "admin" },
    { label: "Custom Fields", path: "/assessment/custom-fields", icon: "📋", permissionLevel: "admin" },
    { label: "All Assessments", path: "/assessment/admin", icon: "👥", permissionLevel: "admin" },
    { label: "Notifications", path: "/assessment/notifications", icon: "🔔", permissionLevel: "admin" },
    { label: "Program & research", path: "/assessment/program", icon: "📚", permissionLevel: "admin" },
  ],

  permissions: {
    view: [],
    create: [],
    edit: [],
    delete: [],
    admin: [],
  },
};

export default assessmentSnapshotModuleConfig;
